Vue.component("cond-view", {
	props: {
		value: {
			type: Object,
		},
	},
	template: `
	<div class="search-cond-component" v-on:change="updateValue">
		<div class="form-group">
			<label class="form-label">地域</label>
			<div class="form-controls">
				<select v-model="area" class="form-control">
					<option value="">すべての地域</option>
					<option value="能登地域">能登地域</option>
					<option value="金沢市内">金沢市内</option>
					<option value="加賀地域">加賀地域</option>
				</select>
			</div>
		</div>
		<div class="form-group">
			<label class="form-label">設備</label>
			<div class="form-controls form-rc-list">
				<div v-for="facility in store.facilities" :key="facility.name" class="checkbox">
					<label>
						<input type="checkbox" v-model="facilities" :value="facility.name">
						<span>{{ facility.label }}</span>
					</label>
				</div>
			</div>
		</div>
		<div class="form-group">
			<label class="form-label">お風呂の種類</label>
			<div class="form-controls form-rc-list">
				<div v-for="feature in store.bathFeatures" :key="feature.name" class="checkbox">
					<label>
						<input type="checkbox" v-model="bathFeatures" :value="feature.name">
						<span>{{ feature.label }}</span>
					</label>
				</div>
			</div>
		</div>
		<div class="form-group">
			<label class="form-label">キーワード</label>
			<div class="form-controls">
				<input type="text" value="" class="form-control" placeholder="店名、店主コメントから検索"
				 v-model="q" v-on:input="updateValue">
			</div>
		</div>
	</div>
	`,
	data() {
		return {
			store,
			area: "",
			has_parking: null,
			q: "",
			facilities: [],
			bathFeatures: [],
		};
	},
	mounted () {
		this.updateInputs()
	},
	methods: {
		updateInputs () {
			Object.keys(this.value).forEach(key => {
				const facility = this.store.facilities.find(f => f.name === key)
				if (facility) {
					this.facilities.push(key)
					return
				}
				const feature = this.store.bathFeatures.find(f => f.name === key)
				if (feature) {
					this.bathFeatures.push(key)
				}
			})
		},
		updateValue() {
			const value = {};
			const wrap = (key, value) => { return {key, value} };

			["area", "has_parking", "q"]
			.map(key => wrap(key, this[key]))
			.filter(kv => kv.value != null && kv.value !== false && kv.value !== "")
			.forEach(kv => value[kv.key] = kv.value);

			this.facilities.forEach(key => value[key] = true);
			this.bathFeatures.forEach(key => value[key] = true);

			this.$emit("input", (Object.keys(value).length > 0) ? value : null);
		}
	},
	watch: {
		value () {
			this.updateInputs()
		}
	}
});
